module.exports = __webpack_public_path__ + "assets/img/c88bec07d037e0863154fe5c90a1708a.svg";